import { defineMessages } from 'react-intl-next';

export const messages: {
    resultLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; status_open: {
        id: string;
        defaultMessage: string;
        description: string;
    }; status_merged: {
        id: string;
        defaultMessage: string;
        description: string;
    }; status_declined: {
        id: string;
        defaultMessage: string;
        description: string;
    }; status_draft: {
        id: string;
        defaultMessage: string;
        description: string;
    }; status_unknown: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	resultLabel: {
		id: 'search-pull-request-result.label',
		defaultMessage: 'Pull request',
		description: 'Search pull request label',
	},
	status_open: {
		id: 'search-pull-request-result.status.open',
		defaultMessage: 'Open',
		description: 'Pull request status label for open pull requests',
	},
	status_merged: {
		id: 'search-pull-request-result.status.merged',
		defaultMessage: 'Merged',
		description: 'Pull request status label for merged pull requests',
	},
	status_declined: {
		id: 'search-pull-request-result.status.declined',
		defaultMessage: 'Declined',
		description: 'Pull request status label for declined pull requests',
	},
	status_draft: {
		id: 'search-pull-request-result.status.draft',
		defaultMessage: 'Draft',
		description: 'Pull request status label for draft pull requests',
	},
	status_unknown: {
		id: 'search-pull-request-result.status.unknown',
		defaultMessage: 'Unknown',
		description: 'Pull request status label for pull requests with unknown status',
	},
});
